import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { languageSuffixMap } from "constant"
import LfsSpecification from "./LfsSpecification"
import classes from "./LfsSpecificationsGroup.module.scss"

const LfsSpecificationsGroup = props => {
  const {
    specification,
    maxSelect,
    selectedSpecificationItems,
    setSelectedSpecificationItems,
    builderStepKey,
    portion
  } = props

  const [t, i18n] = useTranslation()

  const groupName =
    specification[`groupName${languageSuffixMap[i18n.language]}`]

  return (
    <Fragment>
      <div className={classes["title"]}>
        <span className={classes["group-name"]}>
          {groupName}
        </span>

        {
          specification.maxFreeQuantity > 0 &&
          <span className={classes["max-quantity"]}>
            ({t("افزودن_رایگان_تا", { number: specification.maxFreeQuantity })})
          </span>
        }
      </div>

      <div className={classes["options"]}>
        {specification.specificationItems.map(specificationItem =>
          <LfsSpecification
            key={specificationItem._id}
            specification={specification}
            specificationItem={specificationItem}
            maxSelect={maxSelect}
            selectedSpecificationItems={selectedSpecificationItems}
            setSelectedSpecificationItems={setSelectedSpecificationItems}
            builderStepKey={builderStepKey}
            portion={portion}
          />
        )}
      </div>
    </Fragment>
  )
}

export default LfsSpecificationsGroup
